import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';
import { PAGE_Z_INDEX } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/components/StyledComponents';

export const ApprovalStampPlacementArea = styled('div', { label: 'ApprovalStampPlacementArea' })(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: '100%',
  width: '100%',
  zIndex: PAGE_Z_INDEX.APPROVAL_STAMP,
  // Covers the first page while the stamp is shown, so its words do not answer the pointer next to the stamp
  // being placed; a plain press still reaches the page under it, which pans and zooms as usual.
}));

export const ApprovalStampMarker = styled(ButtonBase, { label: 'ApprovalStampMarker' })(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  pointerEvents: 'auto',
  transition: 'opacity 250ms',
  transformOrigin: '0 0',
  backgroundColor: 'transparent',

  '&:hover': {
    cursor: 'move',
  },
}));
